/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateVectorStoreFileRequest = {
  vectorStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createVectorStoreFileRequest: components.CreateVectorStoreFileRequest;
};

/** @internal */
export const CreateVectorStoreFileRequest$inboundSchema: z.ZodType<
  CreateVectorStoreFileRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  CreateVectorStoreFileRequest:
    components.CreateVectorStoreFileRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateVectorStoreFileRequest": "createVectorStoreFileRequest",
  });
});
/** @internal */
export type CreateVectorStoreFileRequest$Outbound = {
  vector_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  CreateVectorStoreFileRequest:
    components.CreateVectorStoreFileRequest$Outbound;
};

/** @internal */
export const CreateVectorStoreFileRequest$outboundSchema: z.ZodType<
  CreateVectorStoreFileRequest$Outbound,
  z.ZodTypeDef,
  CreateVectorStoreFileRequest
> = z.object({
  vectorStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
  createVectorStoreFileRequest:
    components.CreateVectorStoreFileRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    createVectorStoreFileRequest: "CreateVectorStoreFileRequest",
  });
});

export function createVectorStoreFileRequestToJSON(
  createVectorStoreFileRequest: CreateVectorStoreFileRequest,
): string {
  return JSON.stringify(
    CreateVectorStoreFileRequest$outboundSchema.parse(
      createVectorStoreFileRequest,
    ),
  );
}
export function createVectorStoreFileRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateVectorStoreFileRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateVectorStoreFileRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateVectorStoreFileRequest' from JSON`,
  );
}
